import { newE2EPage } from '@stencil/core/testing';

describe('salla-reviews', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<salla-reviews></salla-reviews>');

    const element = await page.find('salla-reviews');
    expect(element).toHaveClass('hydrated');
  });
});
